<template>
    <header class="flex justify-between items-center px-3 py-0" :class="{ shifted }">

        <div>
            <btn-menu v-if="!openedFromCatalog" @menu:show="$emit('menu:show')" :class="{ shifted }" />
            <template v-if="ui.is_desktop_resolution">
                <btn-home v-if="!openedFromCatalog" />
            </template>
            <btn-share v-if="!openedFromCatalog" @menu:hide="$emit('menu:hide')" />

        </div>

        <div>
            <a id="logo" href="https://www.dimm.be/" target="_blank">
                <img src="img/common/dimm-logo.png" alt="logo" class="my-3" style="height:59px;" />
            </a>
        </div>

        <div>
            <btn-search v-if="!openedFromCatalog" />
            <btn-user v-if="!openedFromCatalog" @click="$emit('menu:hide')" />

            <!-- !!! doar daca este logat se afiseaza -->
            <!-- <btn-my-account v-if="isLoggedIn"/>  -->
        </div>

    </header>
</template>

<script>
import BtnHome from "@/components/BtnHome";
import BtnShare from "@/components/BtnShare";
import BtnSearch from "@/components/BtnSearch";
import BtnMenu from "@/components/BtnMenu";
import BtnUser from "@/components/BtnUser";
import BtnMyAccount from './BtnMyAccount.vue';

export default {
    name: "AppHeader",
    components: { BtnUser, BtnMenu, BtnShare, BtnHome, BtnSearch, BtnMyAccount },
    data() {
        return {
            ui: {
                is_mobile_resolution: false,
                is_desktop_resolution: false,
            },
        }
    },
    computed: {
        openedFromCatalog() {
            return window.parent.MainFrame
        }
    },
    props: {
        shifted: Boolean,
    },
    created() {
        let self = this;
        window.addEventListener('resize', function () {
            self._updateResolutionType();
        });

        self._updateResolutionType();
    },

    methods: {
        _onResize: function () {
            var self = this;

            self._updateResolutionType();
        },

        _updateResolutionType: function () {

            var self = this;

            if (window.innerWidth > 1023) {
                self.ui.is_mobile_resolution = false;
                self.ui.is_desktop_resolution = true;
            } else {
                self.ui.is_mobile_resolution = true;
                self.ui.is_desktop_resolution = false;
            }
        },
    }
}
</script>